import { flattenChildren } from '../flattenChildren/flattenChildren.es.js';
import { isComponentType } from '../isComponentType/isComponentType.es.js';

const filterChildrenByType = (children, type) => flattenChildren(children).filter((item) => Array.isArray(type) ? type.some((component) => component === item.type) : isComponentType(item, type));

export { filterChildrenByType };
//# sourceMappingURL=filterChildrenByType.es.js.map
